"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tableau Services APIs
 * Open API specification for Tableau Services APIs
 *
 * The version of the OpenAPI document: latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
const _1 = require("./");
/**
* @export
* @enum {string}
*/
var TableauPublishedconnectionQuerypolicyV1RowFilterPredefinedFilterEnum;
(function (TableauPublishedconnectionQuerypolicyV1RowFilterPredefinedFilterEnum) {
    TableauPublishedconnectionQuerypolicyV1RowFilterPredefinedFilterEnum["UnknownPredefinedFilter"] = "UNKNOWN_PREDEFINED_FILTER";
    TableauPublishedconnectionQuerypolicyV1RowFilterPredefinedFilterEnum["ShowNoRows"] = "SHOW_NO_ROWS";
    TableauPublishedconnectionQuerypolicyV1RowFilterPredefinedFilterEnum["ShowAllRows"] = "SHOW_ALL_ROWS";
})(TableauPublishedconnectionQuerypolicyV1RowFilterPredefinedFilterEnum = exports.TableauPublishedconnectionQuerypolicyV1RowFilterPredefinedFilterEnum || (exports.TableauPublishedconnectionQuerypolicyV1RowFilterPredefinedFilterEnum = {}));
function TableauPublishedconnectionQuerypolicyV1RowFilterFromJSON(json) {
    return TableauPublishedconnectionQuerypolicyV1RowFilterFromJSONTyped(json, false);
}
exports.TableauPublishedconnectionQuerypolicyV1RowFilterFromJSON = TableauPublishedconnectionQuerypolicyV1RowFilterFromJSON;
function TableauPublishedconnectionQuerypolicyV1RowFilterFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'predefinedFilter': !runtime_1.exists(json, 'predefined_filter') ? undefined : json['predefined_filter'],
        'expressionFilter': !runtime_1.exists(json, 'expression_filter') ? undefined : _1.TableauPublishedconnectionQuerypolicyV1ExpressionFilterFromJSON(json['expression_filter']),
    };
}
exports.TableauPublishedconnectionQuerypolicyV1RowFilterFromJSONTyped = TableauPublishedconnectionQuerypolicyV1RowFilterFromJSONTyped;
function TableauPublishedconnectionQuerypolicyV1RowFilterToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'predefined_filter': value.predefinedFilter,
        'expression_filter': _1.TableauPublishedconnectionQuerypolicyV1ExpressionFilterToJSON(value.expressionFilter),
    };
}
exports.TableauPublishedconnectionQuerypolicyV1RowFilterToJSON = TableauPublishedconnectionQuerypolicyV1RowFilterToJSON;
